export function isSvgType(data: Uint8Array): boolean {
  if (!data || data.length === 0) return false;

  // .svgz (gzip) magic bytes: 1F 8B
  if (data.length >= 2 && data[0] === 0x1f && data[1] === 0x8b) {
    return true;
  }

  // Decode only the first few KB (enough for XML prolog + <svg ...)
  const head = new TextDecoder("utf-8", { fatal: false }).decode(
    data.slice(0, 4096),
  );

  // Strip UTF-8 BOM if present
  const normalized = head.replace(/^\uFEFF/, "").trimStart();

  // Accept:
  // - <svg ...>
  // - <?xml ...?><svg ...>
  return /^(?:<\?xml[\s\S]*?\?>\s*)?<svg\b/i.test(normalized);
}

function normalizeContentType(contentType?: string | null): string | null {
  if (!contentType) return null;
  return contentType.split(";")[0]?.trim().toLowerCase() ?? null;
}

export function getMimeType(
  data: ArrayBuffer,
  fallbackContentType?: string | null,
) {
  const normalizedContentType = normalizeContentType(fallbackContentType);
  if (!data) return normalizedContentType;

  const a = new Uint8Array(data);

  // JPEG files can use multiple APPn markers after FF D8 FF.
  if (a.length >= 3 && a[0] === 0xff && a[1] === 0xd8 && a[2] === 0xff) {
    return "image/jpeg";
  }

  if (a.length >= 4) {
    const bytes = [a[0], a[1], a[2], a[3]];

    const signature = bytes
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")
      .toUpperCase();

    switch (signature) {
      case "89504E47":
        return "image/png";
      case "47494638":
        return "image/gif";
      case "25504446":
        return "application/pdf";
      case "504B0304":
        return "application/zip";
      default:
        if (isSvgType(a)) {
          return "image/svg+xml";
        }
        return normalizedContentType;
    }
  }
  return normalizedContentType;
}
